// extracted by mini-css-extract-plugin
export var paginationContainer = "_5v-0";